import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface customerPaymentFormState {}

const initialState: customerPaymentFormState = {
  formValues: {}
};

export const customerPaymentFormSlice = createSlice({
  name: 'confirmedRegisterForm',
  initialState,
  reducers: {
    saveCustomerPaymentForm: (state, action: PayloadAction<any>) => {
      return action.payload;
    },
    resetCustomerPaymentForm: () => initialState
  }
});

export const { saveCustomerPaymentForm, resetCustomerPaymentForm } =
  customerPaymentFormSlice.actions;

export default customerPaymentFormSlice.reducer;
